<template>
  <div class="admin" v-if="admin">
    <div class="admin-head">
      <h2 class="main-title admin-head__tilte_mb">Persönliche Informationen</h2>
    </div>

    <div class="admin-body">
      <form class="admin-form" @submit.prevent="updateInfo" novalidate>
        <div class="admin-form__left">
          <div class="main-form__box">
            <label class="main-form__label">{{$t('forms.name')}}</label>
            <input class="main-form__input" type="text" v-model="admin.first_name" />
          </div>

          <div class="main-form__box">
            <label class="main-form__label">{{$t('forms.surname')}}</label>
            <input class="main-form__input" type="text" v-model="admin.last_name" />
          </div>

          <div class="main-form__box">
            <label class="main-form__label">{{$t('forms.phone')}}</label>
            <vue-tel-input
              v-model="admin.phone"
              @validate="checkValue"
              :placeholder="$t('forms.phone')"
              :inputOptions="{ showDialCode: true }"
              mode="international"
              class="main-vue-tel-input"
              :defaultCountry="defaultCountry"
            ></vue-tel-input>
          </div>
          <div class="main-form__box">
            <label class="main-form__label">E-mail</label>
            <input class="main-form__input" type="text" v-model="admin.email" />
          </div>

          <div class="admin-form__subtitle admin-form__subtitle_mt admin-form__subtitle_mb">
            <p>Passwort ändern</p>
          </div>

          <div class="main-form__box main-form__box_flex main-form__box_between">
            <div class="main-form__half main-form__half_first">
              <label class="main-form__label">{{$t('forms.comeUpPass')}}</label>
              <input
                class="main-form__input"
                type="password"
                v-model="passwords.pass"
                autocomplete="new-password"
              />
            </div>

            <div class="main-form__half main-form__half_second">
              <label class="main-form__label">{{$t('forms.comeUpPassAgain')}}</label>
              <input
                class="main-form__input"
                type="password"
                v-model="passwords.passConfirm"
                autocomplete="new-password"
              />
            </div>
          </div>

          <div class="main-form__box main-form__box_mb40 main-form__box_mt14">
            <button class="main-button">Speichern</button>
          </div>
        </div>

        <div class="admin-form__right">
          <div class="main-uploader">
            <label
              for="main-uploader__input-file"
              class="main-uploader__file"
              :style="{ backgroundImage: 'url(' + admin.big_image + ')' }"
            >
              <img class="main-uploader__icon" src="@/assets/images/addIcon.svg" alt />
              <input
                type="file"
                class="main-uploader__input-file"
                id="main-uploader__input-file"
                @change="updateImg"
              />
            </label>
          </div>

          <!-- <div class="contribution">
            <div class="contribution__checkbox-box">
              <input
                class="contribution__checkbox"
                type="checkbox"
                id="contribution-checkbox"
              />
              <label for="contribution-checkbox" class="contribution__label">
                <img src="@/assets/images/vShape.png" alt />
              </label>
            </div>

            <label for="contribution-checkbox" class="contribution__content">
              <p class="contribution__title">
                Include private contributions on my profile
              </p>
              <p class="contribution__text">
                Get credit for all your work by showing the number of
                contributions to private repositories on your profile without
                any repository or organization information.
              </p>
            </label>
          </div>-->
        </div>
      </form>
    </div>

    <div class="admin-footer">
      <!-- <p class="admin-footer__text">
        We store your personal data in the United States. See our privacy policy
        for more information.
      </p>-->

      <!-- <div class="admin-footer__action">
        <svg
          class="admin-footer__img"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.5455 4.09091V3.27273C6.5455 2.36864 7.27777 1.63636 8.18186 1.63636H9.81823C10.7223 1.63636 11.4546 2.36864 11.4546 3.27273V4.09091H14.7273C15.179 4.09091 15.5455 4.45745 15.5455 4.90909C15.5455 5.36073 15.179 5.72727 14.7273 5.72727V13.9091C14.7273 15.2648 13.6285 16.3636 12.2728 16.3636H5.72732C4.37159 16.3636 3.27277 15.2648 3.27277 13.9091V5.72727C2.82114 5.72727 2.45459 5.36073 2.45459 4.90909C2.45459 4.45745 2.82114 4.09091 3.27277 4.09091H6.5455ZM8.18186 4.09091H9.81823V3.27273H8.18186V4.09091ZM4.90914 13.9091V5.72727H13.091V13.9091C13.091 14.3607 12.7244 14.7273 12.2728 14.7273H5.72732C5.27568 14.7273 4.90914 14.3607 4.90914 13.9091Z"
            fill="var(--menu-text-color)"
          />
        </svg>

        <p class="admin-footer__delete-text">Delete Account</p>
      </div>-->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import store from '../store'

export default {
    computed: {
        ...mapGetters({
            admin: 'adminDataGetters',
            passwords: 'passwordsGetters',
            requestFailed: 'requestFailedGetters',
            formStatus: 'formStatusGetters',
        }),
        isValid() {
            if (this.passwords.pass !== this.passwords.passConfirm) {
                return false
            }

            if (this.passwords.pass !== null && this.passwords.passConfirm) {
                if (this.passwords.pass.length <= 7) {
                    return false
                }
            }

            if (this.admin.first_name === '' || this.admin.first_name === null) {
                return false
            }

            if (this.admin.last_name === '' || this.admin.last_name === null) {
                return false
            }

            if (this.admin.email === '' || this.admin.email === null) {
                return false
            }

            return this.isValidPhone
        },
    },
    data() {
        return {
            isValidPhone: false,
            defaultCountry: this.$config.behavior === 'hilfy' ? 'at' : 'de',
        }
    },
    watch: {
        formStatus(v) {
            if (v === 'success') {
                setTimeout(() => {
                    store.commit('updateStatus', '')
                }, 2000)
            }
        },
    },
    methods: {
        ...mapActions({
            updateAdmin: 'updateAdmin',
            updateAdminImage: 'updateAdminImage',
            logOut: 'logOut',
        }),
        ...mapMutations({
            setAvatarAdmin: 'setAvatarAdmin',
        }),
        logOutFP() {
            this.logOut({ $router: this.$router })
        },
        updateImg(event) {
            const files = event.target.files[0]
            const formData = new FormData()

            if (!files) {
                return
            }

            const vm = this
            const reader = new FileReader()
            reader.readAsDataURL(files)
            reader.onload = () => {
                vm.setAvatarAdmin(reader.result)
            }

            formData.append('image', files)
            this.updateAdminImage(formData)
        },
        async updateInfo() {
            const valid = await this.$validator.validate()

            if (valid) this.updateAdmin()
        },
        checkValue(v) {
            this.isValidPhone = v.valid && v.type === 'mobile'
        },
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.admin {
  margin: 86px 30px 30px 30px;
  padding: 48px 82px;
  width: calc(100% - 60px);
  height: calc(100% - 116px);
  background: var(--bg-color2);
  position: relative;

  &-head {
    &__tilte {
      &_mb {
        margin-bottom: 20px;
      }
    }
  }

  &-form {
    display: flex;
    &__left {
      width: 100%;
      max-width: 620px;
      padding-right: 80px;
    }

    &__right {
      width: 100%;
    }

    &__subtitle {
      font-family: "archivo-medium";
      font-weight: 600;
      font-size: 18px;
      line-height: 29px;
      color: var(--menu-text-color);

      &_mt {
        margin-top: 20px;
      }

      &_mb {
        margin-bottom: 25px;
      }
    }

    .contribution {
      display: flex;
      width: 100%;
      margin-top: 60px;

      &__checkbox-box {
        width: 40px;
        padding-top: 5px;
      }

      &__content {
        width: 100%;
        max-width: 228px;
        user-select: none;
        cursor: pointer;
      }

      &__checkbox {
        display: none;

        &:checked + .contribution__label {
          img {
            display: block;
          }
        }
      }

      &__label {
        border: 1px solid #30333a;
        box-sizing: border-box;
        border-radius: 4px;
        width: 14px;
        height: 14px;
        position: relative;
        display: block;
        cursor: pointer;
        user-select: none;

        img {
          position: absolute;
          right: -6px;
          top: -2px;
          display: none;
        }
      }

      &__title {
        font-family: "archivo-medium";
        font-weight: 600;
        font-size: 15px;
        line-height: 24px;
        color: var(--menu-text-color);
        margin-bottom: 13px;
      }

      &__text {
        font-family: "archivo-medium";
        font-size: 13px;
        line-height: 20px;
        color: #828d99;
      }
    }
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    color: var(--text-color-grey);
    position: absolute;
    width: calc(100% - 140px);
    bottom: 30px;

    &__action {
      display: flex;
      align-items: center;
    }

    &__delete-text {
      width: 98px;
      text-align: right;
      font-size: 13px;
    }
  }
  // @include respond(desktop) {
  //   padding: 40px;
  //   padding: 25px;
  // }
  // &__wrapper {
  //   display: flex;
  //   align-items: stretch;
  //   max-width: 1366px;
  //   @include respond(smalldesk) {
  //     flex-direction: column;
  //   }
  // }
  // &__column {
  //   width: 50%;
  //   border-radius: 8px;
  //   background-color: #ffffff;
  //   box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  //   padding: 36px;
  //   box-sizing: border-box;
  //   @include respond(smalldesk) {
  //     width: 100%;
  //     box-sizing: border-box;
  //   }
  //   &:first-of-type {
  //     margin-right: 24px;
  //     width: 670px;
  //     @include respond(smalldesk) {
  //       margin-right: initial;
  //       margin-bottom: 24px;
  //     }
  //     @include respond(tablet) {
  //       min-width: initial;
  //       max-width: 100%;
  //     }
  //   }
  //   &-title {
  //     display: flex;
  //     justify-content: space-between;
  //     align-items: center;
  //     margin-bottom: 36px;
  //     & .text {
  //       color: $primaryColor;
  //       font-size: 22px;
  //       font-family: $fontBold;
  //     }
  //     & .logout {
  //       display: flex;
  //       align-items: center;
  //       font-size: 16px;
  //       color: #4d4d4d;
  //       font-family: $fontBold;
  //       cursor: pointer;
  //       & img {
  //         margin-left: 10px;
  //       }
  //     }
  //   }
  // }
  // &__info {
  //   &-wrapper {
  //     display: flex;
  //     margin-bottom: 52px;
  //     @include respond(desktop) {
  //       margin-bottom: 10px;
  //     }
  //     @include respond(tablet) {
  //       flex-direction: column;
  //       align-items: center;
  //     }
  //   }
  //   &-img {
  //     position: relative;
  //     width: 200px;
  //     height: 200px;
  //     border-radius: 50%;
  //     border: 2px solid $secondColor;
  //     flex-shrink: 0;
  //     margin-right: 36px;
  //     background-position: center;
  //     background-size: cover;
  //     cursor: pointer;
  //     @include respond(tablet) {
  //       margin-bottom: 16px;
  //     }
  //     & input {
  //       display: none;
  //     }
  //     & .placeholder {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       right: 0;
  //       bottom: 0;
  //       background-image: url("/images/icon/add_avatar.svg");
  //       background-position: center;
  //       background-repeat: no-repeat;
  //       color: #ffffff;
  //       opacity: 0;
  //       transition: 0.5s;
  //     }
  //     &:hover .placeholder {
  //       opacity: 1;
  //     }
  //   }
  //   &-rows {
  //     width: 100%;

  //     & .form-input {
  //       margin-bottom: 16px;
  //       max-width: 360px;
  //       width: 100%;
  //     }
  //   }
  //   &-password {
  //     display: flex;
  //     margin-bottom: 36px;

  //     @include respond(tablet) {
  //       flex-direction: column;
  //       align-items: center;
  //     }
  //     & div {
  //       max-width: 360px;
  //       width: 100%;
  //       position: relative;
  //       @include respond(tablet) {
  //         margin-bottom: 16px;
  //       }
  //       & .form-input {
  //         width: 100%;
  //       }
  //       &:first-of-type {
  //         margin-right: 16px;
  //       }
  //     }
  //     &--failed {
  //       margin-top: 5px;
  //       margin-left: 5px;
  //       font-size: 14px;
  //       color: red;
  //     }
  //   }
  //   &-title {
  //     font-size: 16px;
  //     font-family: $fontBold;
  //     color: #4d4d4d;
  //     margin-bottom: 10px;
  //   }
  //   &-buttons {
  //     display: flex;

  //     & .button {
  //       margin-right: 16px;
  //       width: 156px;
  //       color: $secondColor;
  //     }
  //   }
  // }
  // &__notification {
  //   &-text {
  //     font-size: 16px;
  //     color: #4d4d4d;
  //     &--block {
  //       margin-bottom: 24px;
  //     }
  //   }
  //   &-item {
  //     display: flex;
  //     margin-bottom: 15px;
  //     line-height: 1.5;
  //     & .checkbox {
  //       margin-right: 10px;
  //     }
  //   }
  // }
}
// .load-wrapp {
//   margin-top: 15px;
//   margin-left: 15px;
// }
// .overflow {
//   height: 100%;
// }
</style>
